import { UiFlagsStore } from "../stores/uiFlagsStore";

export enum Environments {
    default = "default",
    localhost = "localhost",
    testing = "testing",
    test = "test", // staging
    prod = "prod"
}

export class Environment {
    public static checkIfTestOrLocalhostEnvironment(uiFlagsStore: UiFlagsStore) {
        return uiFlagsStore.environment === Environments.localhost || uiFlagsStore.environment === Environments.testing ||
            uiFlagsStore.environment === Environments.test;
    }

    public static checkIfLocalhostEnvironment(uiFlagsStore: UiFlagsStore) {
        return uiFlagsStore.environment === Environments.localhost;
    }

    public static checkIsCorrectEnvironment(environment: string) {
        return Object.keys(Environments).includes(environment);
    }
}

